/**
 * Manual Assessment UI toggles (legacy FormRenderer vs common Dynamic Form).
 */

/** Flip to `true` to fall back to legacy FormRenderer when dynamic form is off or has no fields. */
export const SHOW_LEGACY_FORM = false;

/**
 * When true, `@freyr/freyr-react-common` DynamicFormCompBasicJsonSchema renders when
 * `ManualAssessmentForm` `showDynamicForm` is true (default true).
 */
export const SHOW_DYNAMIC_FORM = true;

/**
 * Passed to DynamicFormCompBasicJsonSchema → RJSF Form `omitExtraData`.
 * `false`: keep keys not declared in generated JSON schema (verify submit / required vs stripped fields).
 * `true`: default RJSF behavior (omit extras). Set back to true after schema generation is fixed.
 */
export const DYNAMIC_FORM_OMIT_EXTRA_DATA = false;
